import { render, staticRenderFns } from "./ClassList.vue?vue&type=template&id=33294e5c&scoped=true&"
import script from "./ClassList.vue?vue&type=script&lang=ts&"
export * from "./ClassList.vue?vue&type=script&lang=ts&"
import style0 from "./ClassList.vue?vue&type=style&index=0&id=33294e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33294e5c",
  null
  
)

export default component.exports